import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Products from '../views/Products.vue'
import Contact from '../views/Contact.vue'
import Join from '../views/Join.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    title:'',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    title:'关于我们',
    component: About
  },
  {
    path: '/products',
    name: 'Products',
    title:'产品中心',
    component: Products
  },
  {
    path: '/contact',
    name: 'Contact',
    title:'联系我们',
    component: Contact
  },
  {
    path: '/join',
    name: 'Join',
    title:'招聘信息',
    component: Join
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})


// 全局路由守卫：在路由切换后更新页面标题
router.afterEach((to) => {
  // 尝试从路由配置中获取标题
  let title = null;
  
  // 首先尝试在路由记录中查找title属性
  for (let i = 0; i < to.matched.length; i++) {
    if (to.matched[i].title) {
      title = to.matched[i].title;
      break;
    }
  }
  
  // 如果没找到，尝试从routes数组中获取
  if (!title) {
    const routeConfig = routes.find(route => route.name === to.name);
    if (routeConfig && routeConfig.title) {
      title = routeConfig.title +',诺⾠（河南）生物技术有限公司';
    }
  }
  
  // 设置页面标题，如果还是没有则使用默认标题
  document.title = title || '诺⾠（河南）生物技术有限公司';
})

export default router